import "./StartOrderPage.css";
import PageTitleSlim from "../../components/PageTitleSlim/PageTitleSlim.jsx";
import ObjectMetadata from "../../components/ObjectMetadata/ObjectMetadata.jsx";
import Form from "../../components/Form/Form.jsx";
import SectionTitle from "../../components/SectionTitle/SectionTitle.jsx";
import { useEffect, useState } from "react";
import SubmitResult from "../../components/SubmitResult/SubmitResult.jsx";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner.jsx";
import { useParams } from 'react-router-dom';

const StartOrderPage = () => {
  const [dataLoaded, setDataLoaded] = useState(false);
  const [metadata, setMetadata] = useState({});
  const [numberOfScans, setNumberOfScans] = useState(null);
  const [startAndEndCanvas, setStartAndEndCanvas] = useState(null);
  const [submissionStatus, setSubmissionStatus] = useState("idle");
  const [formData, setFormData] = useState({ email: "", pages: {} });
  const [config, setConfig] = useState({});
  const [fetchError, setFetchError] = useState(false);
  const [configError, setConfigError] = useState(false);
  const [manifestError, setManifestError] = useState(false);
  const [formErrorMessage, setFormErrorMessage] = useState(null);

  // Get objectId from route parameters
  const { objectId } = useParams();

  // handle form submission
  const handleSuccess = (email, pages) => {
    setFormData({ email, pages });
    setSubmissionStatus("success");
  };

  const handleError = (message) => {
    setFormErrorMessage(message);
    setSubmissionStatus("error");
  };

  const getStartAndEndCanvas = (manifest) => {
    const startCanvas = manifest.items[0].id;
    const endCanvas = manifest.items[manifest.items.length - 1].id;
    // get number after last slash
    const start = startCanvas.match(/[^/]+$/)[0];
    const end = endCanvas.match(/[^/]+$/)[0];
    return { start, end };
  };

  useEffect(() => {
    // fetch manifest & config data
    const fetchData = async () => {
      const configUrl =
        process.env.REACT_APP_ENV === "local"
        ? "http://dev-cluster1.onb.ac.at:30518/api/config"
        : "/api/config";
      try {
        // Fetch config file
        const configResponse = await fetch(configUrl);
        if (!configResponse.ok) {
          throw { type: "configError", message: "Failed to load config" };
        }
        const configData = await configResponse.json();
        setConfig(configData);

        // Fetch manifest
        const manifestResponse = await fetch(configData["manifest-url"] + objectId);
        if (!manifestResponse.ok) {
          throw { type: "manifestError", message: "Failed to load manifest" };
        }
        const manifestData = await manifestResponse.json();
        if(!manifestData.items || !manifestData.items.length || !manifestData.metadata) {
          throw { type: "manifestError", message: "Manifest data incomplete" };
        }
        const numberOfScans = manifestData.items.length;
        const startAndEndCanvas = getStartAndEndCanvas(manifestData);
        setMetadata(manifestData.metadata);
        setNumberOfScans(numberOfScans);
        setStartAndEndCanvas(startAndEndCanvas);
        setDataLoaded(true);
      } catch (error) {
        if (error.type === "configError") {
          setConfigError(true);
        }
        else if (error.type === "manifestError") {
          setManifestError(true);
        }
        console.error("Error during fetch:", error.message);
        setFetchError(true);
      }
    };
    fetchData();
  }, [objectId]);

  return (
    <>
      <PageTitleSlim title="PDF Download" />
      <section className="container narrow">
        <SectionTitle
          title={
            submissionStatus === "success"
              ? "Auftrag erfolgreich abgeschickt"
              : "Auftrag erstellen"
          }
        />
        <div className="section-inner">
          <div className="form-container">
            {dataLoaded ? (
              <div>
                <h3>Objekt</h3>
                <ObjectMetadata
                  metadata={metadata}
                  numberOfScans={numberOfScans}
                  startAndEndCanvas={startAndEndCanvas}
                />

                <hr />
                {submissionStatus === "idle" && (
                  <Form
                    objectId={objectId}
                    onSuccess={handleSuccess}
                    onError={handleError}
                    numberOfScans={numberOfScans}
                    startAndEndCanvas={startAndEndCanvas}
                    config={config}
                  />
                )}
                {submissionStatus !== "idle" && (
                  <SubmitResult
                    submissionStatus={submissionStatus}
                    formData={formData}
                    errorMessage={formErrorMessage}
                    objectId={objectId}
                  />
                )}
              </div>
            ) : fetchError ? (
              <div>
                {configError &&
                  <div>
                    <h3>Fehler beim Laden der Daten</h3>
                    <hr />
                  </div>
                }
                {manifestError &&
                  <div>
                    <h3>Fehler beim Laden des Objekts.</h3>
                    <hr />
                  </div>
                }
                <p>Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.</p>
                <hr />
              </div>
            ) : (
              <LoadingSpinner />
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default StartOrderPage;
